<template>
  <div class="special-order-form-portal">
    <component :is="component" :special-order="specialOrder" />
  </div>
</template>
<script lang="ts" setup>
import type { AsyncComponentLoader } from "vue";
import type { StrapiSpecialOrders } from "~/types/strapi";
import { SPECIAL_ORDER_FORM_PORTAL_CONFIG } from "~/modules/special-orders/variables/SpecialOrderFormPortalConfig";

const props = defineProps<{
  specialOrder: StrapiSpecialOrders;
}>();

const component = computed<AsyncComponentLoader>(() => {
  if (!props.specialOrder) {
    throw new Error("Special order page is not defined");
  }

  if (!SPECIAL_ORDER_FORM_PORTAL_CONFIG[props.specialOrder.type]) {
    throw new Error(
      `Component for type ${props.specialOrder.type} is not defined in SPECIAL_ORDER_FORM_PORTAL_CONFIG`,
    );
  }

  return defineAsyncComponent(
    SPECIAL_ORDER_FORM_PORTAL_CONFIG[
      props.specialOrder.type
    ] as AsyncComponentLoader,
  );
});
</script>
